import { AnalyticsBrandSettings, AnalyticsEventData } from 'idt-analytics-api/models';
import { CategoriesHelpers } from 'idt-ecommerce-api/catalog/categories/categories.helpers';
import { getDefaultAnalytics } from '../helpers/events.helper';
import { AnalyticsHelpersOysho } from '../helpers/brand-analytics.helpers.oy';
import { AnalyticsGTMSettings, DefaultAnalyticsSettings } from 'analytics-api';
import { AnalyticsOyshoEventDataHelpers } from '../helpers/brand-analytics-event-data.helpers.oy';

export const HomeEvents: AnalyticsBrandSettings = {

  homeCatalogoClickImage(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { componentData, context } = data;
    let path: string | undefined;
    if (componentData.categoryId && context?.categories) {
      const flatCategories = CategoriesHelpers.flatCategoriesMap(context.categories);
      const sectionPath = flatCategories[componentData.categoryId]?.sectionPathEn;
      path = isDefined(sectionPath) ? AnalyticsHelpersOysho.parsePath(sectionPath) : sectionPath;
    }
    const label = `${componentData?.extraInfo}_${path ?? componentData.slideTitle ?? componentData.pieceName}`;

    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'catalogo', 'home', 'click_image', label);
    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

  homeCatalogoClickButton(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { componentData, context } = data;
    let path: string | undefined;
    if (componentData.categoryId && context?.categories) {
      const flatCategories = CategoriesHelpers.flatCategoriesMap(context.categories);
      const sectionPath = flatCategories[componentData.categoryId]?.sectionPathEn;
      path = isDefined(sectionPath) ? AnalyticsHelpersOysho.parsePath(sectionPath) : sectionPath;
    }
    const label = `${componentData?.extraInfo}_${path ?? componentData.slideTitle ?? componentData.pieceName}`;

    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'catalogo', 'home', 'click_button', label);
    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

  homeNavegacionClickSwiper(data: AnalyticsEventData): AnalyticsGTMSettings {
    const { componentData, context } = data;
    let path: string | undefined;
    if (componentData.categoryId && context?.categories) {
      const flatCategories = CategoriesHelpers.flatCategoriesMap(context.categories);
      const sectionPath = flatCategories[componentData.categoryId]?.sectionPathEn;
      path = isDefined(sectionPath) ? AnalyticsHelpersOysho.parsePath(sectionPath) : sectionPath;
    }
    const label = `${componentData?.carouselSlide}_${path ?? componentData.slideTitle ?? componentData.pieceName}`;

    const eventSettings: DefaultAnalyticsSettings = getDefaultAnalytics('analyticsEvent', 'catalogo', 'home', 'click_swiper', label);
    return AnalyticsOyshoEventDataHelpers.setGTMSettings(eventSettings);
  },

};
